import { useEffect, useRef } from "react";

export const MentionItem = ({ isActive, children, onClick, onMouseEnter }) => {
  const ref = useRef(null);

  useEffect(() => {
    if (isActive) {
      ref.current?.scrollIntoView({ block: "nearest" });
    }
  }, [isActive]);

  return (
    <div
      ref={ref}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      style={{
        padding: "4px 8px",
        cursor: "pointer",
        backgroundColor: isActive ? "#f3f4f6" : "transparent",
      }}
    >
      {children}
    </div>
  );
};
